<template>
  <ion-app>
    <TopNavBar :name="menuTitle" 
              :showDone="showDone"
              :showTitleOnly="showTitleOnly"
              :showSignin="!isSignedIn" @menu-click="menuClick"/>

    <div v-show="!showDone">
      <ProgramMenuContent :key="menuProgramTrigger" @menu-item-click="menuItemClick" 
              @menu-help-item-click="menuHelpItemClick" />
      <YouMenuContent :key="menuYouTrigger" @menu-item-click="menuItemClick"
              @menu-help-item-click="menuHelpItemClick" />
    </div>

    <ion-page id="main-content">
     
      <div v-if="showState == SHOW_CHESSVIS_LANDING" :key="showTrigger">
        <ChessVisLanding whichMenu="mainMenu" @menu-item-click="menuItemClick"></ChessVisLanding>
      </div>

      <div v-if="showState == SHOW_WELCOME" :key="showTrigger">
        <AppLandingView></AppLandingView>
      </div>

      <div v-if="showState == SHOW_DRILL" :key="showTrigger">
        <RepDrillView></RepDrillView>
      </div>
      <div v-if="showState == SHOW_BUILDER" :key="showTrigger">
        <RepBuilderView></RepBuilderView>
      </div>
      <div v-if="showState == SHOW_PRACTICE" :key="showTrigger">
        <RepPracticeView></RepPracticeView>
      </div>
      <div v-if="showState == SHOW_REPERTOIRE_TREE" :key="showTrigger">
        <RepTreeView></RepTreeView>
      </div>
      <div v-if="showState == SHOW_REPMANAGER || showState == SHOW_REPEXPORT" :key="showTrigger">
        <RepManagerView></RepManagerView>
      </div>

      <div v-if="showState == SHOW_EXPLORER || showState == SHOW_EXPLORER_USER_GAMES" :key="showTrigger">
        <ExplorerView></ExplorerView>
      </div>
      <div v-if="showState == SHOW_DOWNLOAD_USER_GAMES" :key="showTrigger">
        <DownloadUserGamesVue></DownloadUserGamesVue>
      </div>
      <div v-if="showState == SHOW_OPENING_AUDIO_BOOKS" :key="showTrigger">
        <AnimateBookView></AnimateBookView>
      </div>

      <div v-if="showState == SHOW_GUARDING" :key="showTrigger">
        <WhosGuardingView></WhosGuardingView>
      </div>
      <div v-if="showState == SHOW_STATIC" :key="showTrigger">
        <StaticBoardView></StaticBoardView>
      </div>
      <div v-if="showState == SHOW_MOVES_RANDOM || showState == SHOW_MOVES_BEGIN || showState == SHOW_MOVES_SPECIFIC" :key="showTrigger">
        <MoveFollowingView></MoveFollowingView>
      </div>

      <div v-if="showState == SHOW_PUZZLE || showState == SHOW_PUZZLE_VISUALIZED || showState == SHOW_PUZZLE_TIMED || showState == SHOW_PUZZLE_TIMED_VISUALIZED || showState == SHOW_PUZZLE_BLINDFOLD
                        || showState == SHOW_PUZZLE_FROM_HISTORY" :key="showTrigger">
        <PuzzlesView @next-item-click="nextItemClick"></PuzzlesView>
      </div>
      <div v-if="showState == SHOW_PUZZLE_OFFLINE" :key="showTrigger">
        <PuzzlesOfflineView></PuzzlesOfflineView>
      </div>
      <div v-if="showState == SHOW_PUZZLE_OFFLINE_TOGGLE" :key="showTrigger">
        <PuzzlesOfflineToggleView></PuzzlesOfflineToggleView>
      </div>
      <div v-if="showState == SHOW_PUZZLE_HISTORY || showState == SHOW_PUZZLE_HISTORY_RETURN"
                   :key="showTrigger">
        <PuzzleHistoryView :isReturn="showState == SHOW_PUZZLE_HISTORY_RETURN"
                     @next-item-click="nextItemClick"></PuzzleHistoryView>
      </div>

      <div v-if="showState == SHOW_PUZZLE_CUSTOM_CATEGORIES" :key="showTrigger">
        <PuzzleCustomCatiew></PuzzleCustomCatiew>
      </div>

      <div v-if="showState == SHOW_BLINDFOLD_REGULAR || showState == SHOW_BLINDFOLD_BLIND
                    || showState == SHOW_BLINDFOLD_CONTINUE" :key="showTrigger">
        <BlindfoldPlayView @menu-item-click="menuItemClick"></BlindfoldPlayView>
      </div>
      <div v-if="showState == SHOW_BLINDFOLD_HISTORY" :key="showTrigger">
        <BlindHistoryView></BlindHistoryView>
      </div>
   
      <div v-if="showState == SHOW_LICHESS_RAPID_CHALLENGE || 
                  showState == SHOW_LICHESS_CORRESPONDENCE_CHALLENGE || 
                  showState == SHOW_LICHESS_FRIEND_CHALLENGE ||
                  showState == SHOW_LICHESS_BOT_CHALLENGE" :key="showTrigger">
        <LichessChallengeView @next-item-click="nextItemClick"></LichessChallengeView>
      </div>

      <div v-if="showState == SHOW_LICHESS_OPEN_GAMELIST" :key="showTrigger">
        <LichessOpenView @next-item-click="nextItemClick"></LichessOpenView>
      </div>

      <div v-if="showState == SHOW_LICHESS_PLAY" :key="showTrigger">
        <LichessPlayView @next-item-click="nextItemClick"></LichessPlayView>
      </div>

      <div v-if="showState == SHOW_LICHESS_ARENA" :key="showTrigger">
        <LichessArenaView @next-item-click="nextItemClick"></LichessArenaView>
      </div>

      <div v-if="showState == SHOW_LICHESS_DISCONNECT" :key="showTrigger">
        <LichessDisconnectView @next-item-click="nextItemClick"></LichessDisconnectView>
      </div>

      <div v-if="showState == SHOW_LICHESS_CONNECT" :key="showTrigger">
        <LichessConnectView @next-item-click="nextItemClick"></LichessConnectView>
      </div>

      <div v-if="showState == SHOW_SIGNIN" :key="showTrigger">
        <LoginView @signin-status-change="signinStatusChange" @next-item-click="nextItemClick"></LoginView>
      </div>

      <div v-if="showState == SHOW_SIGNOFF" :key="showTrigger">
        <LogoffView @signin-status-change="signinStatusChange" @next-item-click="nextItemClick"></LogoffView>
      </div>

      <div v-if="showState == SHOW_REGISTER" :key="showTrigger">
        <RegisterView @signin-status-change="signinStatusChange" @next-item-click="nextItemClick"></RegisterView>
      </div>

      <div v-if="showState == SHOW_SUBSCRIBE_BLURB" :key="showTrigger">
        <!-- <SubscribeBlurbView @next-item-click="nextItemClick"></SubscribeBlurbView> -->
        <SubscribePageView @next-item-click="nextItemClick"></SubscribePageView>
      </div>

      <div v-if="showState == SHOW_STRIPE_SUCCESS" :key="showTrigger">
        <StripeSuccessView></StripeSuccessView>
      </div>

      <div v-if="showState == SHOW_STRIPE_CANCEL" :key="showTrigger">
        <StripeCancelView></StripeCancelView>
      </div>

      <div v-if="showState == SHOW_STRIPE_ACCOUNT" :key="showTrigger">
        <StripeAccountView></StripeAccountView>
      </div>
      <div v-if="showState == SHOW_VERIFY_EMAIL" :key="showTrigger">
        <SendEmailVerifyView></SendEmailVerifyView>
      </div>

      <div v-if="showState == SHOW_EMAIL_VERIFIED" :key="showTrigger">
        <EmailVerifiedView></EmailVerifiedView>
      </div>

      <div v-if="showState == SHOW_PASSWORD_RESET" :key="showTrigger">
        <PasswordResetView></PasswordResetView>
      </div>

      <div v-if="showState == SHOW_UNSUBSCRIBE" :key="showTrigger">
        <UnsubscribeView></UnsubscribeView>
      </div>

      <div v-if="showState == SHOW_PREFERENCES" :key="showTrigger">
        <PreferencesView  @menu-item-click="menuItemClick"></PreferencesView>
      </div>

      <div v-if="showState == SHOW_DELETE_ACCOUNT" :key="showTrigger">
        <DeleteAccountView></DeleteAccountView>
      </div>

      <div v-if="showState == SHOW_CANCEL_SUBSCRIPTION" :key="showTrigger">
        <CancelSubscriptionView @next-item-click="menuItemClick"></CancelSubscriptionView>
      </div>

      <div v-if="showState == SHOW_VIDEO" :key="videoToShow">
        <EasterEggView :videoName="videoToShow"></EasterEggView>
      </div>

      <div v-if="showState == SHOW_CONTACT" :key="showTrigger">
        <ContactView></ContactView>
      </div>

      <div v-if="showState == SHOW_TOS" :key="showTrigger">
        <TOSView></TOSView>
      </div>

      <div v-if="showState == SHOW_VERBAL_LANDING_PAGE" :key="showTrigger">
        <VerbalChessURLView url="https://www.verbalchess.fun/index.html?a=landing"></VerbalChessURLView>
      </div>
       <div v-if="showState == SHOW_VERBAL_PLAY" :key="showTrigger">
        <VerbalChessURLView url="https://www.verbalchess.fun/index_mp3.html?a=play"></VerbalChessURLView>
      </div>
      <div v-if="showState == SHOW_CHESSVIS_AI" :key="showTrigger">
        <AIURLView url="https://www.chessvis.com/ai/index.html?a=from_chessvis"></AIURLView>
      </div>
      <div v-if="showState == SHOW_WHATS_NEW" :key="showTrigger">
        <WhatsNewView></WhatsNewView>
      </div>

      <div v-if="showState == SHOW_LEGACY_EXPLORER_WINLOSS || showState == SHOW_LEGACY_EXPLORER_SLICEDICE" :key="showTrigger">
        <LegacyExplorerView></LegacyExplorerView>
      </div>
      <div v-if="showState == SHOW_LEGACY_MASTER_PLAYER" :key="showTrigger">
        <LegacyMasterPlayerView></LegacyMasterPlayerView>
      </div>
      <div v-if="showState == SHOW_LEGACY_PLAY_COLLECTION" :key="showTrigger">
        <LegacyPlayCollectionView></LegacyPlayCollectionView>
      </div>

      <div v-if="showState == SHOW_LEGACY_REPERTOIRE_TREE" :key="showTrigger">
        <LegacyRepertoireTreeView></LegacyRepertoireTreeView>
      </div>
      <div v-if="showState == SHOW_LEGACY_REPERTOIRE_PRACTICE" :key="showTrigger">
        <LegacyRepertoirePracticeView></LegacyRepertoirePracticeView>
      </div>
      <div v-if="showState == SHOW_LEGACY_REPERTOIRE_BUILDER" :key="showTrigger">
        <LegacyRepertoireBuilderView></LegacyRepertoireBuilderView>
      </div>
      <div v-if="showState == SHOW_LEGACY_REPERTOIRE_MANAGER" :key="showTrigger">
        <LegacyRepertoireManagerView></LegacyRepertoireManagerView>
      </div>
      <div v-if="showState == SHOW_LEGACY_REPERTOIRE_EXPORT" :key="showTrigger">
        <LegacyRepertoireExportView></LegacyRepertoireExportView>
      </div>
      <div v-if="showState == SHOW_LEGACY_REPERTOIRE_IMPORT" :key="showTrigger">
        <LegacyRepertoireImportView></LegacyRepertoireImportView>
      </div>

      <div v-if="showState == SHOW_GRAPH_YOUR_GAMES" :key="showTrigger">
        <GraphYourGamesView></GraphYourGamesView>
      </div>

      <div v-if="showState == SHOW_SHARED_BOARD" :key="showTrigger">
        <SharedBoardView></SharedBoardView>
      </div>

      <div v-if="showState == SHOW_PITCH_COACH" :key="showTrigger">
        <PitchCoachView></PitchCoachView>
      </div>

      <div v-if="showState == SHOW_AI_GAME_SOURCE" :key="showTrigger">
        <BigButtonMenuView whichMenu="aiGameSource" @menu-item-click="menuItemClick"></BigButtonMenuView>
      </div>
      <div v-if="showState == SHOW_AI_ANALYST" :key="showTrigger">
        <GenAIPosition></GenAIPosition>
      </div>
      <div v-if="showState == SHOW_AI_CHATBOT" :key="showTrigger">
        <GenAIChat></GenAIChat>
      </div>

      <div v-if="showState == SHOW_FROMIOS" :key="showTrigger">
        <FromIOSView @from-ios-done="fromIOSDone"></FromIOSView>
      </div>

      <div v-if="showState == SHOW_TACTICS_GYM_LANDING" :key="showTrigger">
        <TacticsGymLanding whichMenu="mainMenu" @menu-item-click="menuItemClick"></TacticsGymLanding>
      </div>
      <div v-if="showState == SHOW_STUDIO_LANDING" :key="showTrigger">
        <StudioLanding whichMenu="mainMenu" @menu-item-click="menuItemClick"></StudioLanding>
      </div>

      <div v-if="showState == SHOW_TACTICS_GYM_MENU" :key="showTrigger">
        <TacticsGym whichMenu="mainMenu" @menu-item-click="menuItemClick"></TacticsGym>
      </div>

      <div v-if="showState == SHOW_HOME_MENU" :key="showTrigger">
        <HomeMenu whichMenu="mainMenu" @menu-item-click="menuItemClick"></HomeMenu>
      </div>
      <div v-if="showState == SHOW_STUDIO_MENU" :key="showTrigger">
        <StudioMenu whichMenu="mainMenu" @menu-item-click="menuItemClick"></StudioMenu>
      </div>

      <div v-if="showState == SHOW_ACCOUNT_MENU" :key="showTrigger">
        <AccountMenu whichMenu="mainMenu" @menu-item-click="menuItemClick"></AccountMenu>
      </div>
      <div v-if="showState == SHOW_STABLE_MENU" :key="showTrigger">
        <StableMenu whichMenu="mainMenu" @menu-item-click="menuItemClick"></StableMenu>
      </div>
      <div v-if="showState == SHOW_BIG_BUTTON_MAIN_MENU" :key="showTrigger">
        <BigButtonMenuView whichMenu="mainMenu" @menu-item-click="menuItemClick"></BigButtonMenuView>
      </div>
      <div v-if="showState == SHOW_BIG_BUTTON_PREFERENCES" :key="showTrigger">
        <BigButtonPreferencesView @menu-item-click="menuItemClick"></BigButtonPreferencesView>
      </div>
    </ion-page>
  </ion-app>
</template>

<script setup >

// the first command gets the thing to work on iphone simulator
// ionic capacitor run ios
//ionic capacitor run ios -l --external

// phase execution compile error on new Xcode
// https://github.com/ionic-team/capacitor/issues/6457
//     source="$(readlink -f "${source}")"



  import { IonApp, IonRouterOutlet , IonPage, menuController } from '@ionic/vue';

  import { useBackButton } from '@ionic/vue';

  import { getPlatforms } from '@ionic/vue';
  import { Device } from '@capacitor/device';
  import { Capacitor } from '@capacitor/core';

  import Toolbar from '@/components/Toolbar.vue';
  import TopNavBar from '@/components/TopNavBar.vue';
  import ProgramMenuContent from '@/components/ProgramMenuContent.vue';
  import YouMenuContent from '@/components/YouMenuContent.vue';

  import { useConnectionStore } from '@/stores/connectionStore';
  import { ref, watch, onMounted, onUnmounted } from 'vue'
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { forceColorsById } from '@/composables/forceColors.js'
  import { getOS } from '@/composables/getData.js'

  import VerbalChessURLView from '@/views/support/VerbalChessURLView.vue'
  import AIURLView from '@/views/support/AIURLView.vue'
  import ContactView from '@/views/support/ContactView.vue'
  import AppLandingView from '@/views/support/AppLandingView.vue'
  import FromIOSView from '@/views/support/FromIOSView.vue'

  import LoginView from '@/views/you/LoginView.vue'
  import LogoffView from '@/views/you/LogoffView.vue'
  import RegisterView from '@/views/you/RegisterView.vue'
  import SubscribeBlurbView from '@/views/you/SubscribeBlurbView.vue'
  import SubscribePageView from '@/views/you/SubscribePageView.vue'
  import StripeSuccessView from '@/views/you/StripeSuccessView.vue'
  import StripeCancelView from '@/views/you/StripeCancelView.vue'
  import StripeAccountView from '@/views/you/StripeAccountView.vue'
  import PreferencesView from '@/views/you/PreferencesView.vue'
  import SendEmailVerifyView from '@/views/you/SendEmailVerifyView.vue'
  import EmailVerifiedView from '@/views/you/EmailVerifiedView.vue'
  import PasswordResetView from '@/views/you/PasswordResetView.vue'
  import DeleteAccountView from '@/views/you/DeleteAccountView.vue'
  import CancelSubscriptionView from '@/views/you/CancelSubscriptionView.vue'

  import UnsubscribeView from '@/views/you/UnsubscribeView.vue'

  import ExplorerView from '@/views/opening/ExplorerView.vue'
  import DownloadUserGamesVue from '@/views/opening/DownloadUserGamesView.vue'
  import AnimateBookView from '@/views/opening/AnimateBookView.vue'

  import RepDrillView from '@/views/repertoire/RepDrillView.vue'
  import RepBuilderView from '@/views/repertoire/RepBuilderView.vue'
  import RepPracticeView from '@/views/repertoire/RepPracticeView.vue'
  import RepTreeView from '@/views/repertoire/RepTreeView.vue'
  import RepManagerView from '@/views/repertoire/RepManagerView.vue'

  import WhosGuardingView from '@/views/visualization/WhosGuardingView.vue'
  import StaticBoardView from '@/views/visualization/StaticBoardView.vue'
  import MoveFollowingView from '@/views/visualization/MoveFollowingView.vue'

  import PuzzlesView from '@/views/puzzles/PuzzlesView.vue'
  import PuzzlesOfflineView from '@/views/puzzles/PuzzlesOfflineView.vue'
  import PuzzlesOfflineToggleView from '@/views/puzzles/PuzzlesOfflineToggleView.vue'
  import PuzzleHistoryView from '@/views/puzzles/PuzzleHistoryView.vue'
  import PuzzleCustomCatiew from '@/views/puzzles/PuzzlesCustomCatView.vue'

  import BlindfoldPlayView from '@/views/engines_play/BlindfoldPlayView.vue'
  import BlindHistoryView from '@/views/engines_play/BlindHistoryView.vue'

  import LichessChallengeView from '@/views/lichess_play/LichessChallengeView.vue'
  import LichessArenaView from '@/views/lichess_play/LichessArenaView.vue'
  import LichessOpenView from '@/views/lichess_play/LichessOpenView.vue'
  import LichessPlayView from '@/views/lichess_play/LichessPlayView.vue'
  import LichessDisconnectView from '@/views/lichess_play/LichessDisconnectView.vue'
  import LichessConnectView from '@/views/lichess_play/LichessConnectView.vue'

  import EasterEggView from '@/views/support/EasterEggView.vue'
  import TOSView from '@/views/support/TOSView.vue'
  import WhatsNewView from '@/views/support/WhatsNewView.vue'

  import LegacyExplorerView from '@/views/legacy_opening/ExplorerWinLossView.vue'
  import LegacyMasterPlayerView from '@/views/legacy_opening/MasterSearchView.vue'
  import LegacyPlayCollectionView from '@/views/legacy_opening/PlayCollectionView.vue'

  import LegacyRepertoireTreeView from '@/views/legacy_repertoire/RepTreeView.vue'
  import LegacyRepertoirePracticeView from '@/views/legacy_repertoire/RepPracticeView.vue'
  import LegacyRepertoireBuilderView from '@/views/legacy_repertoire/RepBuilderView.vue'
  import LegacyRepertoireManagerView from '@/views/legacy_repertoire/RepManagerView.vue'
  import LegacyRepertoireExportView from '@/views/legacy_repertoire/RepExportView.vue'
  import LegacyRepertoireImportView from '@/views/legacy_repertoire/RepImportView.vue'

  import GraphYourGamesView from '@/views/graphs/GraphYourGamesView.vue'

  import SharedBoardView from '@/views/learn/SharedBoardView.vue'
  import PitchCoachView from '@/views/learn/PitchCoachView.vue'
  import GenAIPosition from '@/views/learn/GenAIPosition.vue';
  import GenAIChat from '@/views/learn/GenAIChat.vue';

  const videoRepertoires = "https://www.chessvis.com/videos/chess_opening_mastery_repertoires.mp4"
  const videoExplore2 = "https://www.chessvis.com/videos/chess_opening_mastery_part_2.mp4"
  const videoExplore1 = "https://www.chessvis.com/videos/chess_opening_mastery_part_1.mp4"
  const videoWhoo = "https://www.chessvis.com/videos/whoo.mp4"
  const videoGuarding = "https://www.chessvis.com/videos/guarding.mp4"
  const videoPuzzleVisualization = "https://www.chessvis.com/videos/chessvis_visualization.mp4"
  const videoLegacyMasterPlayer = "https://www.chessvis.com/videos/master_player_web.mp4"
  const videoLegacyPlayCollection = "https://www.chessvis.com/videos/play_against_game_collection.mp4"
  const videoLegacyRepertoires = "https://www.chessvis.com/videos/repertoires_on_web.mp4"

  import { t, setTranslationLanguage } from '@/composables/translateText.js'
  import BigButtonMenuView from '@/views/eyegaze/BigButtonMenuView.vue';
  import BigButtonPreferencesView from '@/views/eyegaze/BigButtonPreferencesView.vue';
  import HomeMenu from '@/views/new_menu/HomeMenu.vue';
  import TacticsGym from '@/views/new_menu/TacticsGym.vue';
  import TacticsGymLanding from '@/views/new_menu/TacticsGymLanding.vue';
  import StudioLanding from '@/views/new_menu/StudioLanding.vue';
  import ChessVisLanding from '@/views/new_menu/ChessVisLanding.vue';
  import StudioMenu from '@/views/new_menu/StudioMenu.vue';
  import AccountMenu from '@/views/new_menu/AccountMenu.vue'
  import StableMenu from '@/views/new_menu/StableMenu.vue'

  import { usePwaStore } from '@/stores/pwaStore';

  var canChangeSize = true

  // stack for android back button
  const maxAndroidStackSize = 100
  var androidStack = []

  const videoToShow = ref(videoWhoo)
  const helpToShow = ref("repmanager")

  const showDone = ref(false)
  const showTitleOnly = ref(false)

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()

  const dummyRef = ref(connectionStore.getDummy)
  const isSignedIn = ref(connectionStore.getDummy == 0)

  setTranslationLanguage()

  // force startup info read on program restart
  connectionStore.setLastStartupDate("0")

  const isDark = ref(connectionStore.getDarkmode != "light")
  
  const processWindowSizeChange = debounce(() => windowSizeChange(),250)
  const processVisualPortSizeChange = debounce(() => windowSizeChange(),250)

  windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)

  const showState = ref(0)
  const showTrigger = ref(0)
  const menuProgramTrigger = ref(0)
  const menuYouTrigger = ref(0)

  const SHOW_WELCOME = 0
  const SHOW_BUILDER = 1
  const SHOW_DRILL = 2
  const SHOW_PRACTICE = 3
  const SHOW_REPMANAGER = 4
  const SHOW_REPEXPORT = 5
  const SHOW_REPERTOIRE_TREE = 6

  const SHOW_EXPLORER = 10
  const SHOW_EXPLORER_USER_GAMES = 11
  const SHOW_DOWNLOAD_USER_GAMES = 12
  const SHOW_OPENING_AUDIO_BOOKS = 13

  const SHOW_GUARDING = 20
  const SHOW_STATIC = 21
  const SHOW_MOVES_RANDOM = 22
  const SHOW_MOVES_BEGIN = 23
  const SHOW_MOVES_SPECIFIC = 24

  const SHOW_PUZZLE = 30
  const SHOW_PUZZLE_VISUALIZED = 31
  const SHOW_PUZZLE_TIMED = 32
  const SHOW_PUZZLE_TIMED_VISUALIZED = 33
  const SHOW_PUZZLE_BLINDFOLD = 34
  const SHOW_PUZZLE_OFFLINE = 35
  const SHOW_PUZZLE_OFFLINE_TOGGLE = 36
  const SHOW_PUZZLE_HISTORY = 37
  const SHOW_PUZZLE_FROM_HISTORY = 38
  const SHOW_PUZZLE_HISTORY_RETURN = 39
  const SHOW_PUZZLE_CUSTOM_CATEGORIES = 40

  const SHOW_LICHESS_RAPID_CHALLENGE = 50
  const SHOW_LICHESS_CORRESPONDENCE_CHALLENGE = 51
  const SHOW_LICHESS_FRIEND_CHALLENGE = 52
  const SHOW_LICHESS_ARENA = 53
  const SHOW_LICHESS_OPEN_GAMELIST = 54
  const SHOW_LICHESS_PLAY = 56
  const SHOW_LICHESS_BOT_CHALLENGE = 57
  const SHOW_LICHESS_DISCONNECT = 58
  const SHOW_LICHESS_CONNECT = 59

  const SHOW_SUBSCRIBE_BLURB = 70
  const SHOW_SIGNIN = 71
  const SHOW_SIGNOFF = 72
  const SHOW_REGISTER = 73
  const SHOW_PREFERENCES = 74
  const SHOW_VERIFY_EMAIL = 75
  const SHOW_EMAIL_VERIFIED = 76
  const SHOW_PASSWORD_RESET = 77
  const SHOW_STRIPE_CANCEL = 78
  const SHOW_STRIPE_SUCCESS = 79
  const SHOW_DELETE_ACCOUNT = 80
  const SHOW_UNSUBSCRIBE = 81
  const SHOW_CANCEL_SUBSCRIPTION = 82
  const SHOW_STRIPE_ACCOUNT = 83

  const SHOW_CONTACT = 90
  const SHOW_TOS = 91
  const SHOW_WHATS_NEW = 92
  const SHOW_FROMIOS = 94
  const SHOW_VERBAL_LANDING_PAGE = 95
  const SHOW_VERBAL_PLAY = 96
  const SHOW_CHESSVIS_AI = 97

  const SHOW_LEGACY_EXPLORER_WINLOSS = 100
  const SHOW_LEGACY_EXPLORER_SLICEDICE = 101
  const SHOW_LEGACY_MASTER_PLAYER = 102
  const SHOW_LEGACY_PLAY_COLLECTION = 103

  const SHOW_LEGACY_REPERTOIRE_TREE = 110
  const SHOW_LEGACY_REPERTOIRE_PRACTICE = 111
  const SHOW_LEGACY_REPERTOIRE_BUILDER = 112
  const SHOW_LEGACY_REPERTOIRE_MANAGER = 113
  const SHOW_LEGACY_REPERTOIRE_EXPORT = 114
  const SHOW_LEGACY_REPERTOIRE_IMPORT = 115

  const SHOW_VIDEO = 120
  const SHOW_HELP = 121

  const SHOW_GRAPH_YOUR_GAMES = 130

  const SHOW_SHARED_BOARD = 140
  const SHOW_PITCH_COACH = 141

  const SHOW_BLINDFOLD_REGULAR = 150
  const SHOW_BLINDFOLD_BLIND = 151
  const SHOW_BLINDFOLD_HISTORY = 152
  const SHOW_BLINDFOLD_CONTINUE = 153

  const SHOW_BIG_BUTTON_MAIN_MENU = 160
  const SHOW_BIG_BUTTON_PREFERENCES = 161

  const SHOW_AI_GAME_SOURCE = 170
  const SHOW_AI_ANALYST = 171
  const SHOW_AI_CHATBOT = 172

  const SHOW_CHESSVIS_LANDING = 180
  const SHOW_TACTICS_GYM_LANDING = 181
  const SHOW_STUDIO_LANDING = 182
  const SHOW_HOME_MENU = 183
  const SHOW_TACTICS_GYM_MENU = 184
  const SHOW_STUDIO_MENU = 185
  const SHOW_ACCOUNT_MENU = 186
  const SHOW_STABLE_MENU = 187

  const urlParams =  new URLSearchParams(window.location.search)
  //console.log("***** URL Parameters",urlParams)

  
  var urlAction = null
  // testing

  //urlAction = "ai"
  //localStorage.setItem("url_game","bob_55f81f1b46261e67");

  //urlAction = "stripe_cancel"
  //urlAction = "stripe_success"
  //urlAction = "stripe_account"

  // urlAction = "passwordreset"
  // urlAction = "emailverified"
  // localStorage.setItem("url_v","NzY2NTcyNjk2Njc5MjAyMA--OGZjMWI0NGMwNzFkMjE0ZDZkMmQ5M2Q1YWQ3MzQ1MWIxZTMxZTg4ZQ--")
  // localStorage.setItem("url_e","henry@conceptual.com")

  // const logDeviceInfo = async () => {
  //   const info = await Device.getInfo();
  //   console.log("**** DEVICE INFO ",info);
  // };

  // logDeviceInfo()

  determineDeviceType()

  // handle back button android.  (try doing it for all)
  //if (connectionStore.getDeviceType == "android") {
    useBackButton(10, () => {
      if (androidStack.length < 2)
        return
      // remove the current routine from the stack and get the info for the one before
      const currentAndroid = androidStack.pop()
      const oneAndroid = androidStack[androidStack.length - 1]
      processMenuItemClick(oneAndroid.programName,oneAndroid.label,
            oneAndroid.whichMenu,true,false)
      //console.log('Back Button Handler was called!');
    });
  //}

  if (urlParams.size > 0) {
    var parametersToDelete = []
    for (const [key, value] of urlParams.entries()) {
      parametersToDelete.push(key)
      if (key == "a")
        urlAction = value
      localStorage.setItem("url_" + key,value)
    }
    // clear the browser line
    const subdir = (process.env.NODE_ENV === 'production') ? "/" : "/"
    history.replaceState(null, "", subdir);
  }
  else {
    // no url options
    localStorage.setItem("url_a","")
  }


  //Honeybadger.notify("Testing Honeybadger!");

  const menuTitle = ref("Welcome")
  //menuItemClick("repbuilder","Builder")
  
  const initialMenu = localStorage.getItem("initialMenu")
  const initialTitle = localStorage.getItem("initialTitle")
  const initialProgram = localStorage.getItem("initialProgram")
  
  var seenNewLandingPage = connectionStore.getSeenNewLandingPage

  if (urlAction != null) {
    switch (urlAction.toLowerCase()) {
      case 'ai' : //
        connectionStore.setUrlIsAI(true)
        menuTitle.value = "AI Analyst"
        showState.value = SHOW_AI_ANALYST
        break
      case 'eyegaze' :  // url is for big menu. force eyegaze.
        connectionStore.setIsEyeGaze(true)
      case 'bigmenu' :
        connectionStore.setShowBigButtons(true)
        menuTitle.value = t("Big Button Menu")
        showState.value = SHOW_BIG_BUTTON_MAIN_MENU
        break
      case 'audiobook' :
        menuTitle.value = t("Opening Audio Book")
        showState.value = SHOW_OPENING_AUDIO_BOOKS
        break
      case 'learn' :
        menuTitle.value = t("Learn With Coach")
        showState.value = SHOW_SHARED_BOARD
        break
      case 'delete_account' :
        menuTitle.value = t("Delete Account")
        showState.value = SHOW_DELETE_ACCOUNT
        break
      case "fromIOS" :
      case "fromAndroid" :
        menuTitle.value = t("Establish Connection")
        showState.value = SHOW_FROMIOS
        break
      case "stripe_cancel" :
        menuTitle.value = t("Order Cancelled")
        showState.value = SHOW_STRIPE_CANCEL
        break
      case "stripe_success" :
        menuTitle.value = t("Order Successful")
        showState.value = SHOW_STRIPE_SUCCESS
        break
      case "stripe_account" :
        menuTitle.value = t("Return from Stripe")
        showState.value = SHOW_STRIPE_ACCOUNT
        break
      case "emailverified" :
        menuTitle.value = t("Email Verified")
        showState.value = SHOW_EMAIL_VERIFIED
        break
      case "passwordreset" :
        menuTitle.value = t("Password Reset")
        showState.value = SHOW_PASSWORD_RESET
        break
      case "unsubscribe" :
        menuTitle.value = t("Unsubscribe")
        showState.value = SHOW_UNSUBSCRIBE
        break
    }
  }
  else
  if (!connectionStore.getSeenNewLandingPage || initialMenu == null || initialTitle == null ||initialProgram == null) {
    menuTitle.value = t("Welcome to Chessvis")
    showState.value = SHOW_CHESSVIS_LANDING
    showTitleOnly.value = true
    // make What's New the home page for now
    //menuTitle.value = "What's New"
    //showState.value = SHOW_WHATS_NEW
  }
  else {

    // TESTING - FORCE CHESSVIS LANDING PAGE
    // menuTitle.value = "Welcome to Chessvis"
    // showState.value = SHOW_CHESSVIS_LANDING
    // showTitleOnly.value = true
    
    //showDone.value = connectionStore.getIsUsingNewMenus
    menuItemClick(initialProgram,initialTitle,(connectionStore.getIsUsingNewMenus) 
            ? "FROM_NEW_MENU" : "initial")
  
  }
  // https://ionicframework.com/docs/api/menu#multiple-menus
  const openProgramMenu = async () => {
    await menuController.open('program-menu');
  };
  const openYouMenu = async () => {
    await menuController.open('you-menu');
  };

  const closeYouMenu = async () => {
    //console.log("close you menu")
    await menuController.close('you-menu');
  };

  const closeProgramMenu = async () => {
    //console.log("close program menu")
    await menuController.close('program-menu');
  };

  // clicked on the item in the menu
  function menuItemClick(programName,label,whichMenu) {
    console.log("******************** MENU ITEM CLICK program",programName)
    console.log("******************** MENU ITEM CLICK label",label)
    console.log("******************** MENU ITEM CLICK whichMenu",whichMenu)
    connectionStore.setTourOption("hide")

    showDone.value = (whichMenu == "FROM_NEW_MENU")
    showTitleOnly.value = whichMenu == "landing"  || whichMenu == "new_menu"  
    processMenuItemClick(programName,label,whichMenu,true,true)
  }

  // used when a program wants to redirect to another program
  function nextItemClick(programName,label,whichMenu) {
    //console.log("******************** MENU ITEM CLICK program",programName)
    //console.log("******************** MENU ITEM CLICK label",label)
    //console.log("******************** MENU ITEM CLICK whichMenu",whichMenu)
    connectionStore.setTourOption("hide")
    processMenuItemClick(programName,label,whichMenu,false,true)
  }

  // set the tour flag and process as usual
  function menuHelpItemClick(programName,label,whichMenu) {
    //console.log("******************** MENU HELP ITEM CLICK ",programName,label)
    connectionStore.setTourOption("show")
    processMenuItemClick(programName,label,whichMenu,true,true)
  }

  function processMenuItemClick(programName,label,whichMenu,updateInitial,putOnAndroidStack) {

    // redirects don't update the initial location
    if (updateInitial) {
      localStorage.setItem("initialMenu",whichMenu)
      localStorage.setItem("initialTitle",label)
      localStorage.setItem("initialProgram",programName)
      if (whichMenu == "program")
        closeProgramMenu()
      if (whichMenu == "you")
        closeYouMenu()
    }

    if (putOnAndroidStack) {
      const oneAndroid = {
        label : label,
        programName : programName,
        whichMenu : whichMenu
      }
      if (androidStack.length >= maxAndroidStackSize)
        androidStack.shift()
      androidStack.push(oneAndroid)
    }

    //console.log("store which menu",whichMenu)
    localStorage.setItem("whichMenu",whichMenu)

    menuTitle.value = label
    switch (programName) {
      case "chessvis_landing_page" :
        showState.value = SHOW_CHESSVIS_LANDING
        break
      case "tactics_gym_landing_page" :
        showState.value = SHOW_TACTICS_GYM_LANDING
        break
      case "studio_landing_page" :
        showState.value = SHOW_STUDIO_LANDING
        break
      case "home_menu" :
        showState.value = SHOW_HOME_MENU
        break
      case "tactics_gym_menu" :
        showState.value = SHOW_TACTICS_GYM_MENU
        break
      case "studio_menu" :
        showState.value = SHOW_STUDIO_MENU
        break
      case "account_menu" :
        showState.value = SHOW_ACCOUNT_MENU
        break
      case "stable_menu" :
        showState.value = SHOW_STABLE_MENU
        break
      case "repexport" :
        connectionStore.setProductOption("export")
        showState.value = SHOW_REPEXPORT
        break
      case "repmanager" :
        connectionStore.setProductOption("manager")
        showState.value = SHOW_REPMANAGER
        break
      case "repbuilder" :
        showState.value = SHOW_BUILDER
        break
      case "repdrill" :
        showState.value = SHOW_DRILL
        break
      case "reppractice" :
        showState.value = SHOW_PRACTICE
        break
      case "reptree" :
        showState.value = SHOW_REPERTOIRE_TREE
        break
      case "explorer" :
        connectionStore.setProductOption("explorer")
        showState.value = SHOW_EXPLORER
        break
      case "download" :
        showState.value = SHOW_DOWNLOAD_USER_GAMES
        break
      case "openingAudioBooks" :
        showState.value = SHOW_OPENING_AUDIO_BOOKS
        break
      case "exploreUserGames" :
        connectionStore.setProductOption("user")
        showState.value = SHOW_EXPLORER_USER_GAMES
        break

      // Puzzles
      case "puzzles" :
        connectionStore.setProductOption("solveit")
        showState.value = SHOW_PUZZLE
        break
      case "puzzle_visualize" :
        connectionStore.setProductOption("visualize")
        showState.value = SHOW_PUZZLE_VISUALIZED
        break
      case "puzzle_timed" :
        connectionStore.setProductOption("timed")
        showState.value = SHOW_PUZZLE_TIMED
        break
      case "puzzle_timed_visualize" :
        connectionStore.setProductOption("timed_visualize")
        showState.value = SHOW_PUZZLE_TIMED_VISUALIZED
        break
      case "puzzle_blindfold" :
        connectionStore.setProductOption("blindfold")
        showState.value = SHOW_PUZZLE_BLINDFOLD
        break
      case "custom_categories" :
        showState.value = SHOW_PUZZLE_CUSTOM_CATEGORIES
        break
      case "puzzle_offline" :
        showState.value = SHOW_PUZZLE_OFFLINE
        break
      case "puzzle_offline_toggle" :
        showState.value = SHOW_PUZZLE_OFFLINE_TOGGLE
        break
      case "puzzle_history" :
        showState.value = SHOW_PUZZLE_HISTORY
        break
      case "puzzle_history_return" : // coming back to history from looking at a puzzle
        showState.value = SHOW_PUZZLE_HISTORY_RETURN
        break
    case "puzzle_from_history" :
        connectionStore.setProductOption("from_history")
        showState.value = SHOW_PUZZLE_FROM_HISTORY
        break
      // Visualization
      case "guarding" :
        showState.value = SHOW_GUARDING
        break
      case "static" :
        showState.value = SHOW_STATIC
        break
      case "moves_random" :
        connectionStore.setProductOption("random")
        showState.value = SHOW_MOVES_RANDOM
        break
      case "moves_begin" :
        connectionStore.setProductOption("begin")
        showState.value = SHOW_MOVES_BEGIN
        break
      case "moves_pieces" :
        connectionStore.setProductOption("pieces")
        showState.value = SHOW_MOVES_SPECIFIC
        break

  
      // Blindfold
      case "play_continue" :
        connectionStore.setProductOption("continue")
        showState.value = SHOW_BLINDFOLD_CONTINUE
        break     
      case "play_computer" :
        connectionStore.setProductOption("computer")
        showState.value = SHOW_BLINDFOLD_REGULAR
        break
      case "play_blindfold" :
        connectionStore.setProductOption("blindfold")
        showState.value = SHOW_BLINDFOLD_BLIND
        break
      case "blindfold_history" :
        showState.value = SHOW_BLINDFOLD_HISTORY
        break

      // LICHESS
      case "lichess_rapid_challenge" :
        connectionStore.setProductOption("rapid")
        showState.value = SHOW_LICHESS_RAPID_CHALLENGE
        break
      case "lichess_correspondence_challenge" :
        connectionStore.setProductOption("correspondence")
        showState.value = SHOW_LICHESS_CORRESPONDENCE_CHALLENGE
        break
      case "lichess_friend" :
        connectionStore.setProductOption("friend")
        showState.value = SHOW_LICHESS_FRIEND_CHALLENGE
        break
      case "lichess_arena" :
        showState.value = SHOW_LICHESS_ARENA
        break
      case "lichess_open_gamelist" :
        showState.value = SHOW_LICHESS_OPEN_GAMELIST
        break
      case "lichess_play" :
        //console.log("IN APP for Play",whichMenu)
        showState.value = SHOW_LICHESS_PLAY
        break
      case "lichess_bot_challenge" :
        connectionStore.setProductOption("bot")
        showState.value = SHOW_LICHESS_BOT_CHALLENGE
        break
      case "lichess_disconnect" :
        showState.value = SHOW_LICHESS_DISCONNECT
        break
      case "lichess_connect" :
        showState.value = SHOW_LICHESS_CONNECT
        break

      // VIDEOS
      case "video_opponent_moves" :
        videoToShow.value = videoExplore1
        showState.value = SHOW_VIDEO
        break
      case "video_best_moves" :
        videoToShow.value = videoExplore2
        showState.value = SHOW_VIDEO
        break
      case "video_repertoires" : 
        videoToShow.value = videoRepertoires
        showState.value = SHOW_VIDEO
        break
      case "video_whoo" :
        videoToShow.value = videoWhoo
        showState.value = SHOW_VIDEO
        break
      case "video_guarding" : 
        videoToShow.value = videoGuarding
        showState.value = SHOW_VIDEO
        break
      case "video_puzzle_visualization" :
        videoToShow.value = videoPuzzleVisualization
        showState.value = SHOW_VIDEO
        break
      case "video_legacy_repertoires" :
        videoToShow.value = videoLegacyRepertoires
        showState.value = SHOW_VIDEO
        break
      case "video_legacy_master" :
        videoToShow.value = videoLegacyMasterPlayer
        showState.value = SHOW_VIDEO
        break
      case "video_legacy_play_collection" :
        videoToShow.value = videoLegacyPlayCollection
        showState.value = SHOW_VIDEO
        break

      case "signin" :
        showState.value = SHOW_SIGNIN
        //console.log("************* SIGNIN")
        break
      case "signoff" :
        showState.value = SHOW_SIGNOFF
        break
      case "register" :
        showState.value = SHOW_REGISTER
        break
      case "subscribe_blurb" :
        showState.value = SHOW_SUBSCRIBE_BLURB
        break
      case "stripe_success" :
        showState.value = SHOW_STRIPE_SUCCESS
        break
      case "stripe_cancel" :
        showState.value = SHOW_STRIPE_CANCEL
        break
      case "preferences" :
        showState.value = SHOW_PREFERENCES
        break
      case "verify_email" :
        showState.value = SHOW_VERIFY_EMAIL
        break
      case "email_verified" :
        showState.value = SHOW_EMAIL_VERIFIED
        break
      case "password_reset" :
        showState.value = SHOW_PASSWORD_RESET
        break
      case "delete_account" :
        showState.value = SHOW_DELETE_ACCOUNT
        break
      case 'cancel_subscription' :
        showState.value = SHOW_CANCEL_SUBSCRIPTION
        break
      case "welcome" :
        showState.value = SHOW_WELCOME
        break
      case "verbal_landing" :
        showState.value = SHOW_VERBAL_LANDING_PAGE
        break
      case "verbal_play" :
        showState.value = SHOW_VERBAL_PLAY
        break
      case "chessvis_ai" :
        showState.value = SHOW_CHESSVIS_AI
        break
      case "whats_new" :
        showState.value = SHOW_WHATS_NEW
        break
      case "contact" :
        showState.value = SHOW_CONTACT
        break
      case "tos" :
        showState.value = SHOW_TOS
        break
      case "legacy_opening_winloss" :
        connectionStore.setProductOption("winloss")
        showState.value = SHOW_LEGACY_EXPLORER_WINLOSS
        break
      case "legacy_opening_slicedice" :
        connectionStore.setProductOption("slicedice")
        showState.value = SHOW_LEGACY_EXPLORER_SLICEDICE
        break
      case "legacy_master_player" :
        showState.value = SHOW_LEGACY_MASTER_PLAYER
        break
      case "legacy_play_collection" :
        showState.value = SHOW_LEGACY_PLAY_COLLECTION
        break

      case "legacy_repertoire_tree" :
        showState.value = SHOW_LEGACY_REPERTOIRE_TREE
        break
      case "legacy_repertoire_practice" :
        showState.value = SHOW_LEGACY_REPERTOIRE_PRACTICE
        break
      case "legacy_repertoire_builder" :
        showState.value = SHOW_LEGACY_REPERTOIRE_BUILDER
        break
      case "legacy_repertoire_manager" :
        showState.value = SHOW_LEGACY_REPERTOIRE_MANAGER
        break
      case "legacy_repertoire_export" :
        showState.value = SHOW_LEGACY_REPERTOIRE_EXPORT
        break
      case "legacy_repertoire_import" :
        showState.value = SHOW_LEGACY_REPERTOIRE_IMPORT
        break

      case "graph_your_games" :
        showState.value = SHOW_GRAPH_YOUR_GAMES
        break

      case "chess_chatbot" :
        showState.value = SHOW_AI_CHATBOT
        break
      case "ai_analyst" :
        showState.value = SHOW_AI_ANALYST
        break
      case "ai_game_source" :
        showState.value = SHOW_AI_GAME_SOURCE
        break
      case "shared_board" :
        showState.value = SHOW_SHARED_BOARD
        break
      case "pitch_coach" :
        showState.value = SHOW_PITCH_COACH
        break

      // big buttons
      case "big_button_menu" :
        showState.value = SHOW_BIG_BUTTON_MAIN_MENU
        break
      case "big_button_preferences" :
        showState.value = SHOW_BIG_BUTTON_PREFERENCES
        break
    }
    showTrigger.value++
  }

  // clicked on the menu icon in the header
  function menuClick(label) {
    console.log("IN APP  ",label)
    if (label == "DONE") {
      // go back to the calling menu
      showDone.value = false
      const callingMenu = connectionStore.getMenuInUse
      switch (callingMenu) {
        case "tactics_gym" :
          showState.value = SHOW_TACTICS_GYM_MENU
          menuTitle.value = t("Tactics Gym")
          showTitleOnly.value = true 
          break
        case "studio" :
          showState.value = SHOW_STUDIO_MENU
          menuTitle.value = t("Studio")
          showTitleOnly.value = true 
          break
        case "account" :
          showState.value = SHOW_ACCOUNT_MENU
          menuTitle.value = t("Account")
          showTitleOnly.value = true 
          break
        case "stable_menu" :
          showState.value = SHOW_STABLE_MENU
          menuTitle.value = t("The Stable")
          showTitleOnly.value = true 
          break
        case "home" :
          showState.value = SHOW_HOME_MENU
          menuTitle.value = t("Home")
          showTitleOnly.value = false 
          break
      }
    }
    else
    if (label == "YOU") {
      menuYouTrigger.value++
      openYouMenu()
    }
    else {
      menuProgramTrigger.value++
      openProgramMenu()
    }
  }

  function fromIOSDone() {
    // redirect to what where they were last

    if (initialMenu == null || initialTitle == null ||initialProgram == null) {
      menuTitle.value = t("Welcome to Chessvis")
      showState.value = SHOW_CHESSVIS_LANDING
    }
    else
      menuItemClick(initialProgram,initialTitle,"initial")
  }

  function signinStatusChange(flag) {
    isSignedIn.value = flag
    //console.log("Signin in APP ",isSignedIn.value)
  }

  function debounce(callback, interval=500) {
    let debounceTimeoutId;

    return function(...args) {
      clearTimeout(debounceTimeoutId);
      debounceTimeoutId = setTimeout(() => callback.apply(this, args), interval);
    };
  }

  function windowSizeChange() {
     //console.log("**** height changed in app ",window.innerHeight,window.innerWidth)
     windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)
  }

  function determineDeviceType() {
    // https://capacitorjs.com/docs/core-apis/web#isnativeplatform
    const isNative = Capacitor.isNativePlatform()
    const platform = Capacitor.getPlatform()
    const platformList = getPlatforms()
    const platformListString = platformList.join(",")
    console.log("Platforms " + platformListString)
    console.log("Native " + isNative + "    platform:" + platform)

    // don't let mobile devices resize but let them change orientation
    canChangeSize = !platformListString.includes("mobile")

    // 4 device types :  native (android, ios)   web (mobile,web)
    if (isNative) {
      if (platform == "android" || platform == "ios")
        connectionStore.setDeviceType(platform)
      else
        connectionStore.setDeviceType("mobile")
    }
    else {
      if (!canChangeSize) {
        // web running on ios or android device
        if (platformListString.includes("ios"))
          connectionStore.setDeviceType("iosweb")
        else
        if (platformListString.includes("android"))
         connectionStore.setDeviceType("androidweb")
        else
          connectionStore.setDeviceType("mobile")
      }
      else
        connectionStore.setDeviceType("web")
    }
  }
  
  const onResizeChange = () => {
    //console.log("**** on resize change")
    if (canChangeSize)
      processWindowSizeChange()

    //console.log("**** height changed in app ",window.innerHeight,window.innerWidth)
    //windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)
  }

  const onOrientationChange = () => {
    const deviceType = connectionStore.getDeviceType
    //console.log("**** on orientation change",deviceType)
    if (!canChangeSize)
      processWindowSizeChange()

    //console.log("**** height changed in app ",window.innerHeight,window.innerWidth)
    //windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)
  }

  const onVisualViewportChange = () => {
    //console.log("**** visual viewport change")
    //console.log("**** height changed in app ",window.innerHeight,window.innerWidth)
    if (canChangeSize)
      processVisualPortSizeChange()
    //windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)
  }

    window.onerror = function(message, source, lineno, colno, error) {
    // Handle the error here
    // Returning true prevents the default browser error message (in older browsers)
    //console.log("got window ONERROR", message)

    return false; 
  };
  
  onMounted(() => {

    const pwaStore = usePwaStore();

    window.addEventListener('resize', onResizeChange)

    window.addEventListener('orientationchange', onOrientationChange)

    visualViewport.addEventListener('resize', onVisualViewportChange)

    var element = document.getElementById("app")
    element.style.height = "100vh"
    element.style.width = "100vw"

    const deviceType = connectionStore.getDeviceType

   
    // https://ionicframework.com/docs/theming/dark-mode
    // get the system value for darkmode
    // Use matchMedia to check the user preference

    // Add or remove the "dark" class on the document body
    const toggleDarkTheme = (shouldAdd) => {

      var darkString = "light"
      // set by the preferences. could be to use the system or force light/dark
      if (shouldAdd) {
        const darkBoardColors = connectionStore.getDarkBoardColors
        if (darkBoardColors != null) {
          if (darkBoardColors == "chessvis" || darkBoardColors == "lichess")
            darkString = darkBoardColors   
          else
            darkString = "dark"
        }
        else
          darkString = "dark"
      }

      document.body.classList.toggle('dark', shouldAdd);
      connectionStore.setDarkMode(darkString )
      //forceColorsById("app",darkString)
    };

    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    toggleDarkTheme(prefersDark.matches);

    // Listen for changes to the prefers-color-scheme media query
    prefersDark.addEventListener('change', 
                  (mediaQuery) => toggleDarkTheme(mediaQuery.matches));

    // set the background for the page
    //forceColorsById("app",connectionStore.getDarkmode)


    // stop scrolling on IOS
    // https://markus.oberlehner.net/blog/simple-solution-to-prevent-body-scrolling-on-ios/#:~:text=The%20most%20straightforward%20way%20for,you%20can%20stop%20reading%20here.

    const osName = getOS(false)
    const osNumber = getOS(true)
    windowSizeStore.updateStoredOSInfo(osName,osNumber)
    
    //alert("OS " + osName + " num " + osNumber)
    if (osName == 'iOS1') {
      const $body = document.querySelector('body');
      let scrollPosition = 0;

      scrollPosition = window.pageYOffset;
      $body.style.overflow = 'hidden';
      $body.style.position = 'fixed';
      //$body.style.top = `-${scrollPosition}px`;
      $body.style.width = '100%';
      window.scrollTo(0, scrollPosition);
    }
  
   
  })

  onUnmounted(() => window.removeEventListener('resize', onResizeChange))
  
</script>

<style>



/*

  https://forum.ionicframework.com/t/ion-menu-will-not-scroll-unless-main-page-has-overflow/194163

ion-content {
  --overflow: hidden;
} */

.text-dark {
  color : white;
  background-color : black;
  border-color: white;
}

.text-light {
  background-color : white;
  color : black;
  border-color : black;
}

ion-action-sheet.my-custom-class {
    --background: #f58840;
    --backdrop-opacity: 0.6;
    --button-background-selected: #e97223;
    --button-color: #000000;
    --color: #fff;
    /* role: "destructive" button iOS styling override */
    --ion-color-danger: #000000;
  }


</style>
